import { AxiosError } from "axios";

import { getTokenClientes } from "../../Store/storages/AuthenticationStorage";
import { apiClientes } from "../../config/api";
import { Convite } from "../../interfaces/entities/SaudeBemEstar/PalestrasEventos/Convite";
import { Evento } from "../../interfaces/entities/SaudeBemEstar/PalestrasEventos/Evento";

export const getInvitations = async (): Promise<Convite[]> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get("/Cronicos/getconviteseventos", { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};

export const getInvitation = async (params: Pick<Evento, "idCtrlEventoUsr" | "idCtrlProgEvento">): Promise<Convite | null> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get("/cronicos/getselecionaconvite", { headers, params });
    return response.data;
  } catch (error) {
    return null;
  }
};

export const getEvents = async (): Promise<Evento[]> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get("/Cronicos/geteventos", { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};

export const postConfirmAttendance = async (body: Pick<Evento, "idCtrlEventoUsr" | "idCtrlProgEvento">): Promise<void> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    await apiClientes.post("/Cronicos/ConfirmarPresencaEvento", body, { headers });
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};

export const postCancelAttendance = async (body: Pick<Evento, "idCtrlEventoUsr" | "idCtrlProgEvento" | "idCtrlProgEventoUsr">): Promise<void> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    await apiClientes.post("/Cronicos/CancelarPresencaEvento", body, { headers });
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};
